import './bootstrap';

import {downloadJpgChart, downloadPngChart, downloadSvgChart, exportChart} from "./charts/utilities";

import {Alpine, Livewire} from '../../vendor/livewire/livewire/dist/livewire.esm';
import {registerWppUi} from '../../vendor/bernskiold/wpp-ui-blade/resources/js';
import {registerWppWysiwyg} from '../../vendor/bernskiold/wpp-ui-blade/resources/js/wysiwyg';
import Clipboard from "@ryangjchandler/alpine-clipboard";
import highchartsChart from "./charts/highchartsChart";
import '../../vendor/wire-elements/pro/resources/js/overlay-component.js';
import "flatpickr";
import AlpineFloatingUI from '@awcodes/alpine-floating-ui';
import Copy from "./alpine-components/copy";
import FlourishChart from "./charts/flourishChart";
import ChartLabels from "./alpine-components/chartLabels";
import {initializeDynamicVideo, voteForQuestion} from "./blings-dynamic-video";
import '@wotz/livewire-sortablejs';
import WppOpenAuthentication from "./alpine-components/wpp-open-authentication";
import canvas from './alpine-components/canvas';
import bavApp from './alpine-components/bav-app';
import bavSqlEditor from './alpine-components/bav-sql-editor';
import translatableDescriptionList from "./alpine-components/translatable-description-list";
import listSparkline from "./alpine-components/list-sparkline";
import filterBar from "./alpine-components/filter-bar";
import floatingPanel from "./alpine-components/floating-panel";

/**
 * The BAV entry point. Vantage has its own in `vantage.js`; both import the
 * shared modules directly, and neither imports the other.
 */
window.Fount = {
    charts: {
        downloadSvg: downloadSvgChart,
        downloadJpg: downloadJpgChart,
        downloadPng: downloadPngChart,
    },
    dynamicVideo: {
        init: initializeDynamicVideo,
        voteCallback: voteForQuestion,
    }
};

/**
 * Chart downloads asked for on the server, where the file name is worked out,
 * take the same path as the download buttons from here.
 */
window.addEventListener('export-chart-requested', (event) => {
    exportChart(event.detail.chartId, event.detail.type, event.detail.filename);
});

/**
 * A toast's link button, which the design system raises as an event because
 * the toast sits outside every Livewire component.
 */
window.addEventListener('wpp-notification-visit', (event) => {
    window.location.assign(event.detail.url);
});

window.addEventListener('postMessage', event => {
    window.postMessage(event.detail);
});

/**
 * Alpine
 *
 * The design system's components, and the tooltip plugin they rely on, come
 * from wpp-ui-blade.
 */
registerWppUi(Alpine);
registerWppWysiwyg(Alpine);
Alpine.plugin(Clipboard);
Alpine.plugin(AlpineFloatingUI);
Alpine.data('copy', Copy);
Alpine.data('highchartsChart', highchartsChart);
Alpine.data('flourishChart', FlourishChart);
Alpine.data('chartLabels', ChartLabels);
Alpine.data('wppOpenAuthentication', WppOpenAuthentication);
Alpine.data('canvas', canvas);
Alpine.data('bavApp', bavApp);
Alpine.data('bavSqlEditor', bavSqlEditor);
Alpine.data('translatableDescriptionList', translatableDescriptionList);
Alpine.data('listSparkline', listSparkline);
Alpine.data('filterBar', filterBar);
Alpine.data('floatingPanel', floatingPanel);

Livewire.start();
